import apiSportsFederations from '@/api/sports-federations'

const state = {
    validationErrors: null,
    isSubmitting: false
}

export const mutationTypes = {
    deleteSportFederationsStart: '[delete sportsFederations] deleteSportFederationsStart',
    deleteSportFederationsSuccess: '[delete sportsFederations] deleteSportFederationsSuccess',
    deleteSportFederationsFailure: '[delete sportsFederations] deleteSportFederationsFailure'
}

export const actionType = {
    deleteSportFederations: '[delete sportsFederations] deleteSportFederations'
}

const mutations = {
    [mutationTypes.deleteSportFederationsStart](state) {
        state.isSubmitting = true
        state.validationErrors = null
    },

    [mutationTypes.deleteSportFederationsSuccess](state) {
        state.isSubmitting = false
    },

    [mutationTypes.deleteSportFederationsFailure](state, payload) {
        state.isSubmitting = false
        state.validationErrors = payload
    }
}

const actions = {
    [actionType.deleteSportFederations](context, {id}) {
        context.commit(mutationTypes.deleteSportFederationsStart)
        return new Promise(resolve => {
            apiSportsFederations
                .deleteSportFederation(id)
                .then(response => {
                    context.commit(mutationTypes.deleteSportFederationsSuccess, response.data)
                    resolve(response.data)
                })
                .catch(result => {
                    context.commit(
                        mutationTypes.deleteSportFederationsFailure,
                        result.response.data.errors
                    )
                })
        })
    }
}

export default {
    state,
    mutations,
    actions
}
